import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import SingleProjectInfo from "./SingleProject";
import projectExample from "./149.json";
import { withRouter } from "react-router-dom";
import ErrorPage from "../section-components/Error";
import { dedupeProjectTeam } from "./dedupeProjectTeam";

function ProjectDetailsInner() {
  const [proj, setProj] = useState([]);
  const [loaded, setloaded] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let url = window.location.pathname;
    let split = url.split("/");
    let directId = parseInt(split[2]);
    console.log(window.config.bolseirosUiId);
    if (!window.config.bolseirosUiId) {
      setError(true);
      setLoading(false);
      return;
    }
    try {
      axios
        .get("https://adit.ipvc.pt/modulosipvc_producao/rest-api-slimv3/api/proxyv3/" + directId)
        .then((res) => {
          setProj(res.data.data[0]);
        })
        .finally(() => {
          setLoading(false);
          setloaded(true);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  }, []);
  const uniqueTeam = useMemo(
    () => dedupeProjectTeam(proj?.team ?? []),
    [proj?.team]
  );

  if (error) {
    return <ErrorPage />;
  }
  return (
    <>
      {loading && (
        <div className="preloader">
          <div className="main-circle">
            <div className="green-circle">
              <div className="brown-circle"></div>
            </div>
          </div>
        </div>
      )}
      {/* <!-- start team details area --> */}
      <section className="team-detail pt-120 mt-120">
        <div className="container">
          <div className="row">
            {loaded && (
              <div className="col-lg-4">
                <SingleProjectInfo projeto={proj} />
              </div>
            )}
            {proj && (
              <div className="col-lg-8">
                <div
                  className="team-inner right-part"
                  style={{ textAlign: "justify", textJustify: "inter-word" }}
                >
                  {proj.summary && (
                    <div className="single-item">
                      <div className="item-title">
                        <h4>About</h4>
                      </div>
                      <p className="item justify">{proj.summary}</p>
                    </div>
                  )}
                  <div className="single-item mt-30">
                    <div className="item-title">
                      <h4>Team</h4>
                    </div>
                    {uniqueTeam.map((item) => {
                      let webSiteName = item.name;
                      let fullName = item.name;
                      let role = item.coordination ? 'Coordenador Institucional' : 'Membro'
                      if (item.name.includes(" - ")) {
                        [webSiteName, fullName] = item.name.split(" - ");
                      }
                      return (
                        <div key={item.id ?? item.email ?? fullName} className="project-team-name">
                          <p>
                            {fullName} - <b>{role}</b>
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default withRouter(ProjectDetailsInner);
